import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "time-edit-view" }
const _hoisted_2 = { class: "row v-center gap" }
const _hoisted_3 = { class: "items row col" }
const _hoisted_4 = { class: "h1" }
const _hoisted_5 = {
  key: 0,
  class: "h4 gray"
}
const _hoisted_6 = {
  key: 1,
  class: "h4 gray"
}
const _hoisted_7 = { class: "scroll row col gap" }
const _hoisted_8 = { class: "row col sm-gap" }
const _hoisted_9 = {
  key: 0,
  class: "gray"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "bold" }
const _hoisted_12 = {
  key: 0,
  class: "wide"
}
const _hoisted_13 = {
  key: 0,
  class: "error"
}
const _hoisted_14 = {
  key: 0,
  class: "loading-box"
}
const _hoisted_15 = {
  key: 1,
  class: "times"
}
const _hoisted_16 = { class: "row col sm-gap" }
const _hoisted_17 = { class: "bold row v-center" }
const _hoisted_18 = {
  key: 0,
  class: "box"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "small"
}
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 1,
  class: "small red"
}
const _hoisted_23 = { key: 2 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 2,
  class: "gray row center v-center sm-gap"
}
const _hoisted_26 = { class: "row spaced" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_section = _resolveComponent("date-section")!
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_si_currency = _resolveComponent("si-currency")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "close-button link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'OrderTime' })))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "gg-close" }, null, -1)
      ])),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "fill row center h2" }, "Swap activity", -1))
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _cache[4] || (_cache[4] = _createElementVNode("small", null, "You are swapping", -1)),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.source?.name), 1),
      (_ctx.activityDateString)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.activityDateString), 1))
        : _createCommentVNode("", true),
      (!!_ctx.time?.Rates.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.rates), 1))
        : _createCommentVNode("", true)
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "bold" }, "Swap to", -1)),
        (!_ctx.targets.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "There are no activities available to swap to."))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targets, (target) => {
          return (_openBlock(), _createElementBlock("div", {
            key: target.EntityHierarchyKey,
            class: _normalizeClass(["row spaced gap v-center time target", { selected: _ctx.activity?.entityHierarchyKey == target.EntityHierarchyKey }]),
            onClick: ($event: any) => (_ctx.selectTarget(target))
          }, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(target.Name), 1),
            (_ctx.activity?.entityHierarchyKey == target.EntityHierarchyKey)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[5] || (_cache[5] = [
                  _createElementVNode("div", { class: "gg-check" }, null, -1)
                ])))
              : _createCommentVNode("", true)
          ], 10, _hoisted_10))
        }), 128))
      ]),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true),
      (_ctx.activity && !_ctx.error)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_date_section),
            (_ctx.loading || _ctx.activity.getTimesLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_loader_display)
                ]))
              : (_ctx.activity.availableTimes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.availableTimes, (t) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: t.DisplayName ?? -1,
                        class: "row spaced gap v-center time"
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createTextVNode(_toDisplayString(t.DisplayName) + " ", 1),
                            (t.Description)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(t.Description), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["time-details", _ctx.priceClass(t)])
                          }, [
                            _cache[7] || (_cache[7] = _createTextVNode(" Subtotal: ", -1)),
                            _createVNode(_component_si_currency, {
                              amount: t.SubTotal,
                              class: "pad-right"
                            }, null, 8, ["amount"]),
                            (_ctx.hasCapacity(t))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, "• " + _toDisplayString(t.TotalAvailable) + " spot" + _toDisplayString(t.TotalAvailable == 1 ? '' : 's') + " available", 1))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        (t.CallToBook)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _cache[8] || (_cache[8] = _createTextVNode(" To book this time, please call us at ", -1)),
                              _createElementVNode("a", {
                                href: `tel:${_ctx.phoneNumber}`
                              }, _toDisplayString(_ctx.phoneNumber), 9, _hoisted_21)
                            ]))
                          : (!_ctx.hasCapacity(t))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Not enough space for " + _toDisplayString(_ctx.requiredParticipants) + " guest" + _toDisplayString(_ctx.requiredParticipants == 1 ? '' : 's'), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createElementVNode("button", {
                                  class: "blue",
                                  onClick: ($event: any) => (_ctx.book(t))
                                }, "Select", 8, _hoisted_24)
                              ]))
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[9] || (_cache[9] = [
                    _createElementVNode("div", { class: "gg-info" }, null, -1),
                    _createTextVNode(" This date has no availability, please select another ", -1)
                  ])))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("button", {
        class: "row v-center gray",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
      }, _cache[10] || (_cache[10] = [
        _createElementVNode("span", { class: "gg-chevron-left" }, null, -1),
        _createTextVNode(" Back", -1)
      ]))
    ])
  ]))
}